class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videoOverlay = this?.querySelector(".video-overlay");
    this.videoOverlay?.addEventListener("click", this?.handleClick?.bind(this));
  }

  handleClick() {
    const iframe = this?.querySelector("iframe");

    if (iframe) {
      iframe.src = `${iframe?.src}?autoplay=1`;
      this.videoOverlay.style.display = "none";
    }
  }
}

customElements.define("video-player", VideoPlayer);
